import type { HelpFile } from '../../types/help'
import { AccountsTestIds } from '../../../testids/AccountsTestIds'

export const accountsHelp: HelpFile = {
  docPage: '/docs/identity/accounts',
  texts: {
    [AccountsTestIds.accountsList]:
      'Alle dem System bekannten Konten, nach Zielsystem gruppiert. Ein Konto ist die Berechtigungsdarstellung, die in einem nachgelagerten System tatsächlich Zugriff erhält.',
  },
}
